module.exports = __webpack_public_path__ + "img/prop-1.42b2e1d2.png";